import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface ImageBuilderVersion {
  _id: string;
  imageUrl: string;
  prompt: string;
  aspectRatio: string;
  model?: string;
  createdAt: Date;
  storagePath?: string;
  enhancePrompt?: string;
  instruction?: string;
}

export interface ImageBuilderDraft {
  _id: string;
  contentId: string;
  createdAt: Date;
  updatedAt: Date;
  status: 'draft' | 'generating' | 'completed' | 'failed';
  currentVersionId?: string;
  versions: ImageBuilderVersion[];
  mediaContexts?: { url: string; mimeType?: string; filename?: string; type?: string }[];
}

@Injectable({
  providedIn: 'root',
})
export class ImageGeneratorService {
  private apiUrl = `${environment.apiUrl}image-builder`;

  constructor(private http: HttpClient) {}

  getDrafts(contentId: string): Observable<ImageBuilderDraft[]> {
    return this.http.get<ImageBuilderDraft[]>(`${this.apiUrl}/drafts/${contentId}`);
  }

  createDraft(data: { contentId: string }): Observable<ImageBuilderDraft> {
    return this.http.post<ImageBuilderDraft>(`${this.apiUrl}/drafts`, data);
  }

  updateDraft(draftId: string, data: Partial<ImageBuilderDraft>): Observable<ImageBuilderDraft> {
    return this.http.patch<ImageBuilderDraft>(`${this.apiUrl}/drafts/${draftId}`, data);
  }

  generateImage(data: { contentId: string; prompt: string; aspectRatio: string; model?: string; mediaContexts?: any[]; draftId?: string }): Observable<ImageBuilderDraft> {
    return this.http.post<ImageBuilderDraft>(`${this.apiUrl}/generate`, data);
  }

  deleteDraft(draftId: string): Observable<void> {
    // Note: Delete endpoint isn't implemented in backend Phase 1 yet
    return this.http.delete<void>(`${this.apiUrl}/drafts/${draftId}`);
  }
  addVersion(data: { draftId: string; instruction: string; aspectRatio?: string; model?: string; referenceVersionId?: string; mediaContexts?: any[] }): Observable<ImageBuilderDraft> {
    return this.http.post<ImageBuilderDraft>(`${this.apiUrl}/drafts/${data.draftId}/versions`, {
      instruction: data.instruction,
      aspectRatio: data.aspectRatio,
      model: data.model,
      referenceVersionId: data.referenceVersionId,
      mediaContexts: data.mediaContexts,
    });
  }
  deleteVersion(draftId: string, versionId: string): Observable<ImageBuilderDraft | null> {
    return this.http.delete<ImageBuilderDraft | null>(`${this.apiUrl}/drafts/${draftId}/versions/${versionId}`);
  }
}
